import React from "react";
import "../Styles/_AddressInformation.css";

const AddressInformation = ({ currentLanguage, address, addressType }) => {
    const header =
        addressType === "BILLING"
            ? currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.BILLING.HEADING
            : currentLanguage.ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.SHIPPING.HEADING;
    /*
        Return false if address is empty.
        Only billing address cases.
    */
    if (!address || !address.address1) {
        return false;
    }

    return (
        <div className="address-information-container allow-focus" tabIndex="0">
            <h2 className="title">{header}</h2>
            <div className="layout vertical address-information-body">
                <span>{`${address.first_name || ""} ${address.last_name || ""}`}</span>
                <span>
                    {address.address1 || ""}
                    {address.address2 && (
                        <React.Fragment>
                            <br />
                            {address.address2}
                        </React.Fragment>
                    )}
                </span>
                <span>{`${address.city || ""}, ${address.province || ""} ${address.zip || ""}`}</span>
                <span>{address.country || ""}</span>
            </div>
        </div>
    );
};

export default AddressInformation;



// WEBPACK FOOTER //
// ./src/views/Order/components/_AddressInformation.jsx